import TYPES from './types';

export const setAsyncFilterValues = params => dispatch => {
  dispatch({ type: TYPES.SET_ASYNC_FILTER_VALUES, payload: params });
};
